var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.318,58.672c-3.796,0-6.884,3.088-6.884,6.884s3.088,6.884,6.884,6.884s6.884-3.088,6.884-6.884 S32.114,58.672,28.318,58.672z M28.318,68.439c-1.59,0-2.884-1.294-2.884-2.884s1.293-2.884,2.884-2.884s2.884,1.294,2.884,2.884 S29.908,68.439,28.318,68.439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.318,41.116c-3.796,0-6.884,3.088-6.884,6.884s3.088,6.884,6.884,6.884s6.884-3.088,6.884-6.884 S32.114,41.116,28.318,41.116z M28.318,50.884c-1.59,0-2.884-1.294-2.884-2.884c0-1.59,1.293-2.884,2.884-2.884 S31.202,46.41,31.202,48C31.202,49.59,29.908,50.884,28.318,50.884z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.318,23.56c-3.796,0-6.884,3.088-6.884,6.884s3.088,6.884,6.884,6.884s6.884-3.088,6.884-6.884 S32.114,23.56,28.318,23.56z M28.318,33.328c-1.59,0-2.884-1.294-2.884-2.884s1.293-2.884,2.884-2.884s2.884,1.293,2.884,2.884 S29.908,33.328,28.318,33.328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.237,32.444h27.33c1.104,0,2-0.896,2-2s-0.896-2-2-2h-27.33c-1.104,0-2,0.896-2,2S44.132,32.444,45.237,32.444z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.566,46h-27.33c-1.104,0-2,0.896-2,2s0.896,2,2,2h27.33c1.104,0,2-0.896,2-2S73.671,46,72.566,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.566,63.556h-27.33c-1.104,0-2,0.896-2,2s0.896,2,2,2h27.33c1.104,0,2-0.896,2-2S73.671,63.556,72.566,63.556z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.83c85cb6eec2c3a03a2fa8d1cfeee96d.svg";
export { ForwardRef as ReactComponent };